import React, { useState, useEffect, useRef } from 'react';
import ModalForm from '../../../../components/modalComponents/ModalForm';
import InputText from '../../../../components/modalComponents/InputText';
import InputSelect from '../../../../components/modalComponents/InputSelect';
import InputUploadFile from '../../../../components/modalComponents/InputUploadFile';
import { useForm } from '../../../../hooks/useForm/UseForm';
import { useSubmitForm } from "../../../../hooks/useSubmitForm/useSubmitForm";
import { useGetOptionsSelect } from '../../../../hooks/useGetOptionsSelect/useGetOptionsSelect';
import useDidMountEffect from '../../../../hooks/useDidMountEffect/useDidMountEffect';
import { getOrigenDocumentoAPI, getPlantillasAPI, crearConfiguracionDocumentoAPI, getNuevosIngresosPasosObligatoriosOptionsAPI } from '../../../../consumers/backendApisUrls';
import InputBool from '../../../../components/modalComponents/InputBool';

const CrearDocumento = ({ toggleModal, refreshPage }) => {
  const isMounted = useRef(true);
  const SECTION_NAME = "CrearNuevoDocumento";
  const KEYS = {
    DocumentName: "NombreDocumento",
    Origin: "IdOrigen",
    Template: "IdPlantilla",
    File: "File",
    PasosObligatorios: "IdNuevosIngresosPasoObligatorio",
    EsContrato: "EsContrato",
  };
  const SHOW_OPTIONS = {Plantilla: {id: 1, label: KEYS.Template, component: InputSelect}, Formato: {id: 2, label: KEYS.File, component: InputUploadFile}}
  
  const [formValues, setFormValues] = useState({
    [KEYS.EsContrato]: false,
  });
  const [allOrigins, setAllOrigins] = useState([]);
  const [allTemplates, setAllTemplates] = useState([]);
  const [allPasos, setAllPasos] = useState([]);
  const [componentsSelected, setComponentsSelected] = useState({});
  const [buttonDisabled, setButtonDisabled] = useState(false);

  const [handleChange] = useForm(formValues, setFormValues);

  const [getOptions] = useGetOptionsSelect();
  const [submitForm] = useSubmitForm();

  const init = async () => {
    try {
      setAllOrigins(await getOptions(getOrigenDocumentoAPI()));
      setAllPasos(await getOptions(getNuevosIngresosPasosObligatoriosOptionsAPI()));
    } catch (error) {
      console.error(error);
    }
  }

  const submit = async (e) => {
    e.preventDefault();
    const api = crearConfiguracionDocumentoAPI()
    let payload = getPayload();
    setButtonDisabled(true);
    await submitForm(Object.values(KEYS), api, payload, SECTION_NAME, successSubmitCallback, true, () => setButtonDisabled(false))
  };

  const getPayload = () => {
    let basicStates = {
      [KEYS.DocumentName]: formValues[KEYS.DocumentName],
      [KEYS.Origin]: formValues[KEYS.Origin]?.value,
      [KEYS.PasosObligatorios]: formValues[KEYS.PasosObligatorios]?.value,
      [KEYS.EsContrato]: formValues[KEYS.EsContrato],
    };
    if (componentsSelected.label){
      let newStates = {[componentsSelected.label]: formValues[componentsSelected.label]?.value ?? formValues[componentsSelected.label]}
      return {...basicStates, ...newStates}
    }
    return basicStates;
  }

  const successSubmitCallback = function () {
    setButtonDisabled(false);
    refreshPage();
    toggleModal();
  }

  const getSelectedData = async () => {
    if ( formValues[KEYS.Origin]?.value === SHOW_OPTIONS.Plantilla.id){
      let templates = !allTemplates.length ? await getOptions(getPlantillasAPI()) : allTemplates;
      setAllTemplates(templates);
      return {label: "Plantilla", options: templates, value: formValues[KEYS.Template], onChange: handleChange, name: KEYS.Template, sectionName: SECTION_NAME, isRequired: true}
    } else if (formValues[KEYS.Origin].value == SHOW_OPTIONS.Formato.id) {
      return {label: "Archivo", setUploadFile: (res) => setFormValues(lastData => ({...lastData, [KEYS.File]: res})), id:"agregarFormatoTemplate", validExtensions:["pdf"], sectionName: SECTION_NAME, name: KEYS.File, isRequired: true}
    }
    return {};
  }

  const findComponent = () => {
    return Object.values(SHOW_OPTIONS).find(o => o.id === formValues[KEYS.Origin]?.value)
  }
  
  useDidMountEffect( async () => {
    let data = await getSelectedData();
    let componentSelected = findComponent();
    setComponentsSelected({...componentSelected, data});
  }, [formValues[KEYS.Origin], formValues[KEYS.Template]])

  useEffect(() => {
    if (isMounted) init();

    return () => {
      isMounted.current=false;
    }
  }, [])

  return (
    <ModalForm onSubmit={submit} showModal={toggleModal} width="700px" titulo="Nuevo documento" saveButtonDisabled={buttonDisabled}>
      <InputText label="Nombre de documento" value={formValues[KEYS.DocumentName]} onChange={handleChange} name={KEYS.DocumentName} sectionName={SECTION_NAME} isRequired/>
      <InputSelect label="Origen del documento" options={allOrigins} value={formValues[KEYS.Origin]} onChange={handleChange} name={KEYS.Origin} sectionName={SECTION_NAME} isRequired/>
      <InputSelect label="Paso Obligatorio" options={allPasos} value={formValues[KEYS.PasosObligatorios]} onChange={handleChange} name={KEYS.PasosObligatorios} sectionName={SECTION_NAME} isRequired/>
      {componentsSelected?.id && 
        <componentsSelected.component {...componentsSelected.data}/>
      }
      <InputBool label="Es contrato" value={formValues[KEYS.EsContrato]} onChange={handleChange}  name={KEYS.EsContrato} sectionName={SECTION_NAME} isRequired />
    </ModalForm>
  )
}

export default CrearDocumento;